import { Checkbox } from 'antd';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';

interface Props {
  onChange?: (e: any) => void;
  checked: boolean;
  label?: string;
  name: string;
  noRound?: boolean;
}

const DefaultCheckBox = ({ onChange, checked, label, name, noRound = false }: Props) => {
  return (
    <CheckboxWrapper $noRound={noRound}>
      <Checkbox name={name} type="checkbox" onChange={onChange} checked={checked}>
        {label && <span>{label}</span>}
      </Checkbox>
    </CheckboxWrapper>
  );
};

export default DefaultCheckBox;

const CheckboxWrapper = styled.div<{ $noRound: boolean }>`
 pointer-events: auto;

.ant-radio-group .ant-radio-wrapper .ant-radio-inner {
  border-color: #9e9e9e;
  border-width: 2px;
}

.ant-radio-group .ant-radio-wrapper .ant-radio-inner::after {
  background-color: #0c0c0c;
  width: 20px;
  height: 20px;
  margin-block-start: -10px;
  margin-inline-start: -10px;
}

.ant-checkbox-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;


    .ant-checkbox{
      
        .ant-checkbox-inner{
            width:24px;
            height:24px;
            &:after{
                top: 11.5px;
                left: 7px;
                width: 7px;
                height: 12px;
            }
        }
        &+span{
            padding:0;
            ${font.body_medium}

            
        }
    }
    .ant-checkbox-checked .ant-checkbox-inner{
        background-color: ${color.white};
        border-color: ${color.black2};

        &:after {
            border-color:  ${color.black2};
        }
    }
    &:hover{
        .ant-checkbox-inner{
            border-color:#B7B7B7;
            background-color:${color.opacityBlack01};
            box-shadow: 0px 0px 0px 4px ${color.opacityBlack01};
        }
        .ant-checkbox-checked .ant-checkbox-inner{
            background-color: ${color.white} !important;
            border-color: ${color.black2} !important;
    }
  }
`;
